import React from 'react';

import { Button, Modal, TextField } from '@atom/mui';
import config from '@atom/selectors/config';
import colors from '@atom/styles/colors';
import layout from '@atom/styles/layout';

import classes from './folders.module.css';

const styles = {
  dialog: {
    rot: {},
    bodyStyle: { margin: 0, padding: 0, border: 0 },
    contentStyle: {
      width: layout.mediumModalWidth,
      height: '200px',
      left: '50%',
      marginLeft: '-250px',
    },
    actionsContainerStyle: {
      paddingRight: '1rem',
      paddingBottom: '1rem',
    },
  },
  iconStyle: {
    color: colors.neutral.gray,
  },
  actionButtons: {
    cancel: { marginRight: '1rem' },
  },
  actionsContainerStyle: {
    paddingRight: '1rem',
    paddingBottom: '1rem',
  },
};

const initialState = {
  open: false,
  name: '',
};

interface Props {
  folderId?: string;
  folderPath?: any[];
  name: string;
  type: string;
  editAction: (folderId: string, folderPath: any[], name: string) => void;
  open?: boolean;
  closeModal?: () => void;
}

interface State {
  open: boolean;
  name: string;
}

class EditMediaFolderModal extends React.Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      ...initialState,
      open: props.open,
      name: props.name,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.open) {
      this.setState({
        open: nextProps.open,
        name: nextProps.name,
      });
    }
  }

  closeModal = () => {
    const { closeModal } = this.props;

    this.setState({ ...initialState });
    return closeModal();
  };

  onChange = event => {
    const { name: property, value } = event.target;

    // @ts-ignore
    this.setState({ [property]: value });
  };

  confirm = () => {
    const { name } = this.state;
    const { folderId, editAction, folderPath } = this.props;

    editAction(folderId, folderPath, name);
    this.closeModal();
  };

  setErrorText = () => {
    const { name } = this.state;

    if (name?.length === 0) {
      return 'The folder name cannot be blank';
    }

    if (name?.length >= config.MAX_CHARACTERS_FOLDER_NAME) {
      return 'The folder name cannot exceed 50 characters';
    }

    return '';
  };

  render() {
    const { open, name } = this.state;
    const disabled = !name || name.length >= config.MAX_CHARACTERS_FOLDER_NAME;

    const getFooter = () => {
      return (
        <div style={styles.dialog.actionsContainerStyle}>
          <Button sx={styles.actionButtons.cancel} onClick={this.closeModal}>
            Cancel
          </Button>
          <Button
            disabled={disabled}
            onClick={this.confirm}
            color="primary"
            variant="contained"
          >
            Save
          </Button>
        </div>
      );
    };

    return !open ? (
      <div />
    ) : (
      <Modal
        title="Rename Folder"
        style={styles.dialog.contentStyle}
        footer={getFooter()}
        open={open}
        onCancel={this.closeModal}
      >
        <div className={classes.modalContainer}>
          <TextField
            label="Folder Name"
            value={name}
            name="name"
            error={this.setErrorText().length > 0}
            helperText={this.setErrorText()}
            onChange={this.onChange}
          />
        </div>
      </Modal>
    );
  }
}

export default EditMediaFolderModal;
